var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirtable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.7871,
    cy: 51.4745,
    rx: 48.7871,
    ry: 48.5255,
    fill: "#F0F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5643 27.1938L26.2799 36.4146C25.0407 36.9275 25.0535 38.688 26.3005 39.1823L48.6778 48.0562C50.6439 48.8359 52.8335 48.8359 54.7996 48.0562L77.1772 39.1819C78.4238 38.688 78.4374 36.9278 77.1975 36.415L54.9138 27.1934C52.8807 26.3522 50.5969 26.3522 48.5639 27.1934",
    fill: "#FFC021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7238 52.8997V75.0682C53.7238 76.1223 54.787 76.8446 55.7671 76.4561L80.7022 66.7774C80.9803 66.6672 81.2189 66.4759 81.387 66.2285C81.555 65.981 81.6449 65.6887 81.6448 65.3896V43.2214C81.6448 42.167 80.5816 41.445 79.6015 41.8335L54.6664 51.5122C54.3883 51.6225 54.1498 51.8138 53.9818 52.0612C53.8137 52.3087 53.7238 52.6009 53.7238 52.9",
    fill: "#18BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9022 54.0458L40.502 57.6188L39.7507 57.982L24.1293 65.467C23.1394 65.9447 21.8752 65.2231 21.8752 64.1231V43.3164C21.8752 42.9184 22.0792 42.5748 22.3529 42.3164C22.4652 42.2046 22.5925 42.1091 22.7313 42.0326C23.1043 41.8086 23.6367 41.7488 24.0894 41.9279L47.7779 51.3139C48.982 51.7916 49.0766 53.4789 47.9022 54.0461",
    fill: "#F82B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M47.9017 54.0458L40.5015 57.6188L22.3523 42.3161C22.4646 42.2044 22.592 42.109 22.7307 42.0326C23.1037 41.8086 23.6361 41.7488 24.0889 41.9279L47.7773 51.3139C48.9814 51.7916 49.076 53.4789 47.9017 54.0461",
    fill: "#15181D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 77.5H75",
    stroke: "#455CD8",
    strokeWidth: 1.7586,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.75 81.25V73.75",
    stroke: "#455CD8",
    strokeWidth: 1.54442,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77.5H10",
    stroke: "#465DD8",
    strokeWidth: 1.7586,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 82.5V72.5",
    stroke: "#465DD8",
    strokeWidth: 1.54442,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 16.25H60",
    stroke: "#0F248D",
    strokeWidth: 1.7586,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.75 20V12.5",
    stroke: "#0F248D",
    strokeWidth: 1.54442,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4384 84.5554C37.6125 86.3797 37.9216 89.5962 36.1281 91.7335C34.3347 93.8708 31.1134 94.125 28.9393 92.3008C26.7652 90.4765 26.4562 87.26 28.2496 85.1227C30.0431 82.9853 33.2644 82.7312 35.4384 84.5554Z",
    stroke: "#455CD8",
    strokeWidth: 1.43974
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5362 22.5961C26.2438 24.029 26.4669 26.5787 25.034 28.2863C23.6012 29.9938 21.0515 30.2169 19.3439 28.7841C17.6364 27.3513 17.4133 24.8015 18.8461 23.094C20.2789 21.3864 22.8287 21.1633 24.5362 22.5961Z",
    stroke: "#455CD8",
    strokeWidth: 1.15024
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9414 16.9851C94.8914 19.4605 95.2485 23.899 92.7384 26.8905C90.2283 29.8819 85.7952 30.3009 82.8452 27.8255C79.8952 25.3502 79.538 20.9116 82.0481 17.9202C84.5582 14.9288 88.9914 14.5098 91.9414 16.9851Z",
    stroke: "#0F248D",
    strokeWidth: 2.01507
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtable);
export default __webpack_public_path__ + "static/media/Airtable.db5768b3.svg";
export { ForwardRef as ReactComponent };